import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../axios.js';
import moment from 'moment/moment';

import './Resources/dashboard.css';


function Create_stock(){

  


   //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/*if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{
   */}


    
      
//Variables
const[Tbanks,setTbanks] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();

//date
const[date,setdate]=useState();const updatedate = (event) => { setdate(event.target.value);}; const[date_er,setdate_er]=useState();
//type
const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);  updateDispatchType(); }; const[type_er,settype_er]=useState();
//particular
const[particular,setparticular]=useState();const updateparticular = (event) => { setparticular(event.target.value);}; const[particular_er,setparticular_er]=useState();
//quantity
const[quantity,setquantity]=useState();const updatequantity = (event) => { setquantity(event.target.value);}; const[quantity_er,setquantity_er]=useState();
//bank_id
const[bank_id,setbank_id]=useState();const updatebank_id = (event) => { setbank_id(event.target.value);}; const[bank_id_er,setbank_id_er]=useState();
//dispatch_type
const[dispatch_type,setdispatch_type]=useState();const updatedispatch_type = (event) => { setdispatch_type(event.target.value); updateDispatchType(); }; const[dispatch_type_er,setdispatch_type_er]=useState();
//commodity
const[commodity,setcommodity]=useState();const updatecommodity = (event) => { setcommodity(event.target.value);}; const[commodity_er,setcommodity_er]=useState();
//booking_number
const[booking_number,setbooking_number]=useState();const updatebooking_number = (event) => { setbooking_number(event.target.value);}; const[booking_number_er,setbooking_number_er]=useState();
//vehicle_type
const[vehicle_type,setvehicle_type]=useState();const updatevehicle_type = (event) => { setvehicle_type(event.target.value);}; const[vehicle_type_er,setvehicle_type_er]=useState();
//vehicle_number
const[vehicle_number,setvehicle_number]=useState();const updatevehicle_number = (event) => { setvehicle_number(event.target.value);}; const[vehicle_number_er,setvehicle_number_er]=useState();
//eway_bill_no
const[eway_bill_no,seteway_bill_no]=useState();const updateeway_bill_no = (event) => { seteway_bill_no(event.target.value);}; const[eway_bill_no_er,seteway_bill_no_er]=useState();
//einvoice_no
const[einvoice_no,seteinvoice_no]=useState();const updateeinvoice_no = (event) => { seteinvoice_no(event.target.value);}; const[einvoice_no_er,seteinvoice_no_er]=useState();
//quantity_booked
const[quantity_booked,setquantity_booked]=useState();const updatequantity_booked = (event) => { setquantity_booked(event.target.value);}; const[quantity_booked_er,setquantity_booked_er]=useState();
//quantity_dispatched
const[quantity_dispatched,setquantity_dispatched]=useState();const updatequantity_dispatched = (event) => { setquantity_dispatched(event.target.value);}; const[quantity_dispatched_er,setquantity_dispatched_er]=useState();
//balance_quantity
const[balance_quantity,setbalance_quantity]=useState();const updatebalance_quantity = (event) => { setbalance_quantity(event.target.value);}; const[balance_quantity_er,setbalance_quantity_er]=useState();
//bcode
const[bcode,setbcode]=useState();const updatebcode = (event) => { setbcode(event.target.value);}; const[bcode_er,setbcode_er]=useState();
//bname
const[bname,setbname]=useState();const updatebname = (event) => { setbname(event.target.value);}; const[bname_er,setbname_er]=useState();
//vendor_name
const[vendor_name,setvendor_name]=useState();const updatevendor_name = (event) => { setvendor_name(event.target.value);}; const[vendor_name_er,setvendor_name_er]=useState();

//dispatch_val
const[dispatch_val,setdispatch_val]=useState(0); //const updatedispatch_val = (event) => { setdispatch_val(event.target.value);}; const[dispatch_val_er,setdispatch_val_er]=useState();


//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




useEffect(()=>{
   
  getData();
  
  },[])
 

  
    
  
//******************* GET GODOWNS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 
 axios.post("godownslist", {
   Log_id:logid,
   Token:token,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0
 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setTbanks(response.data.data);
  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET GODOWNS DATA FUNCTION END  ********************//

 function updateDispatchType(){
    const btype = document.getElementById("type").value;
    const dtype = document.getElementById("dispatch_type").value; 
    if(btype=="entry"){
        setdispatch_type("none");
        document.getElementById("dit").style.display="none";
    }
   
    else{
         document.getElementById("dit").style.display="block";
    }

    if(dtype=="booking"){
      document.getElementById("bid").style.display="block";
    }
    else{
       document.getElementById("bid").style.display="none";
    }
  
 }
  
//******************* CREATE GODOWN FUNCTION START ********************//
function createstock(){

  //Setting Error Variables
setdate_er(" ");settype_er(" ");setdispatch_type_er(" "); setparticular_er(" ");setquantity_er(" ");setcommodity_er(" ");setbooking_number_er(" ");
setvehicle_number_er(" ");setvehicle_type_er(" ");seteway_bill_no_er(" ");seteinvoice_no_er(" ");
seterror_msg(" ");

  if((type=="drawings")&&(dispatch_type=="none")){
          setdispatch_type_er("Dispatch type cannot be none for drawings !");
          return;
    }

  //if(eway_bill_no)

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
    
    
  const addBtn = document.getElementById("emp-submit-btn");
  addBtn.disabled = true;
  addBtn.innerText = "Processing..."; // optional
 
  axios.post("createstock", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Date : moment(date).format('YYYY-MM-DD'),
   Type:type,
   Dispatch_type:dispatch_type,
   Godown_id:document.getElementById("bank_id").value,
   Particular : particular,
   Quantity : quantity,
   Commodity:commodity,
   Booking_number:booking_number,
   Vehicle_number: vehicle_number,
   Vehicle_type:vehicle_type,
   Eway_bill_no: eway_bill_no,
   Einvoice_no:einvoice_no,
   Update_dispatch_val:dispatch_val
 })
 .then((response) => {
  
  
    // In case of network or server error
    addBtn.disabled = false;
    addBtn.innerText = "submit";

    //Transaction Limit Reached
    if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
  // else if(response.data.error==103){     seterror_msg(response.data.error_msg); return; }


    //Transaction Limit Reached
    if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }


  //Invalid Session
  else if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
 else if(response.data.validatorerror){
  setdate_er(response.data.validatorerror.Date);
  settype_er(response.data.validatorerror.Type);
  setdispatch_type_er(response.data.validatorerror.Dispatch_type);
  setparticular_er(response.data.validatorerror.Particular);
  setquantity_er(response.data.validatorerror.Quantity);
  setcommodity_er(response.data.validatorerror.Commodity);
  setbooking_number_er(response.data.validatorerror.Booking_number);
  setbank_id_er(response.data.validatorerror.Godown_id);
  setvehicle_number_er(response.data.validatorerror.Vehicle_number);
  setvehicle_type_er(response.data.validatorerror.Vehicle_type);
  seteway_bill_no_er(response.data.validatorerror.Eway_bill_no);
  seteinvoice_no_er(response.data.validatorerror.Einvoice_no);
  seterror_msg("Cannot Add Transaction!"); 
}
//Invalid Entries
else if(response.data.error==102){ 
  
  setdate_er(response.data.date_er);
  settype_er(response.data.type_er);
  setdispatch_type_er(response.data.dispatch_type_er);
  setparticular_er(response.data.particular_er);
  setquantity_er(response.data.quantity_er);
  setcommodity_er(response.data.commodity_er);
  setbooking_number_er(response.data.booking_number_er);
  setbank_id_er(response.data.godown_id_er);
  setvehicle_number_er(response.data.vehicle_number_er);
  setvehicle_type_er(response.data.vehicle_type_er);
  seteway_bill_no_er(response.data.eway_bill_no_er);
  seteinvoice_no_er(response.data.einvoice_no_er);
  seterror_msg("Cannot Add Transaction!");  }


  //Invalid Entries
  else if(response.data.error==103){    
     seterror_msg(response.data.error_msg); 
     //checking andsetting for booking value
     if(response.data.myval==22){
      document.getElementById("update-booking-btn").style.display="block";
     }

   }

   //Transaction Entered Successfully
   else if(response.data.successvar==1){        document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Add Transaction !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* CREATE STOCK FUNCTION END ********************//


 //******************* CREATE STOCK BY BOOKING NUMBER FUNCTION START ********************//

 //Edit Function
 function getstockbybooking_number(){
  
 
   const bankid=booking_number;
 
   //Checking if user loggedin
   if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
  
  
  axios.post("stockdetailsbybookingnumber", {
    Log_id:logid,
    Token:token,
    Busy_id:busyid,
    Counter_id:counterid,
    Edit_id:bankid,
 
  })
  .then((response) => {

 
   //Invalid Session
   if((response.data.error)==100){ 
       //Remove Session Variables and redirect to login
      sessionStorage.removeItem("logStatus00");
      sessionStorage.removeItem("logId00");
      sessionStorage.removeItem("logToken00");
      sessionStorage.removeItem("BusyId00");
      sessionStorage.removeItem("CounterId00");
      sessionStorage.removeItem("Bankid00");
 
 
      window.location.replace("businesstools-login");
   }
   //Success Data Fetched
   if(response.data.successvar==1){

    //Setting Data
   
    setcommodity(response.data.commodity); 
    setquantity(response.data.balance_quantity);
    setquantity_booked(response.data.booked_quantity);
    setquantity_dispatched(response.data.dispatched_quantity);
    setbcode(response.data.bcode);
    setbname(response.data.bname);
    setvendor_name(response.data.vendor_name);

    
    document.getElementById("biid").style.display="block";
 

   }
   //Cannot Fetch Data
   else{
 
 


        }
  
  
  });
  
  }
  //User not Logedin
  else{
 
      //Checking if user loggedin
      if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))){
  
  //Remove Session Variables and redirect to login
    sessionStorage.removeItem("logStatus00");
    sessionStorage.removeItem("logId00");
    sessionStorage.removeItem("logToken00");
    sessionStorage.removeItem("BusyId00");
    sessionStorage.removeItem("CounterId00");
 
    window.location.replace("businesstools-login");
      }
  
   }
  
  }
   
  //******************* GET STOCK DATA BY BOOKING NUMBER FUNCTION END  ********************//
 
const [stockCsv, setStockCsv] = useState(null);
const [bulkMsg, setBulkMsg] = useState("");
const [bulkErrors, setBulkErrors] = useState([]);

  function uploadStockCsv() {

  setBulkMsg("");
  setBulkErrors([]);

  if (!stockCsv) {
    setBulkMsg("Please select CSV file");
    return;
  }

  const formData = new FormData();
  formData.append("file", stockCsv);
  formData.append("Log_id", logid);
  formData.append("Token", token);

  axios.post("bt_createstock_bulk_csv", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
  .then((res) => {

    if (res.data.error == 100) {
      sessionStorage.clear();
      window.location.replace("businesstools-login");
      return;
    }

    if (res.data.successvar == 1) {
      setBulkMsg(
        "Inserted: " + res.data.inserted +
        " | Skipped: " + res.data.skipped
      );
      setBulkErrors(res.data.errors || []);
    } else {
      setBulkMsg(res.data.error_msg);
    }
  });
}


return(
    <>
                <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("create-form").style.display="none"; }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Stock Transaction</h4>
                    <div class="form-sample">
                      <p class="card-description">enter your stock transactions here</p>
                      <code>{error_msg}</code>
                      <button class="btn btn-outline-primary" id="update-booking-btn" style={{fontWeight:"bold", display:"none", marginBottom:"2rem"}}  onClick={()=>{ setdispatch_val(1); createstock(); }}>Update Booking Number and Submit</button>
                      
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Dispatch Date<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="date" value={date} onChange={updatedate} />
                              <code>{date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Select Transaction" id="type" value={type} onChange={updatetype}>
                              <option value="">Select Transaction</option>
                              <option value="entry">Entry</option>
                              <option value="drawings">Drawings</option>
                              </select>
                              <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="row">
                        <div class="col-md-6" id="dit">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Dispatch Type<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Select Dispatch Type" id="dispatch_type" value={dispatch_type} onChange={updatedispatch_type}>
                              <option value="">Select Dispatch Type</option>
                              <option value="booking">booking</option>
                              <option value="other">other</option>
                              <option value="none">none</option>
                              </select>
                              <code>{dispatch_type_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Commodity<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" id="commodity" value={commodity} onChange={updatecommodity} style={{padding:"1rem"}}>
                              <option value="">Select Commodity</option>
                              <option value="sugar S">sugar S</option>
                              <option value="sugar S30">sugar S30</option>
                              <option value="sugar M">sugar M</option>
                              <option value="sugar M30">sugar M30</option>
                              <option value="molasses">molasses</option>
                              <option value="brown sugar">brown sugar</option>
                              <option value="sugar M super">sugar M super</option>
                              <option value="sugar S super">sugar S super</option>
                              <option value="cane seed">cane seed</option>
                              </select>
                              <code>{commodity_er}</code>
                            </div>
                          </div>
                      </div>
                      </div>
                      <div clas="row"  id="bid">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Booking Number<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="BK2025-12-140001" id="booking_number" value={booking_number} onChange={updatebooking_number} />
                              <code>{booking_number_er}</code>
                            </div>
                          </div>
                      </div>
                        <div class="col-md-6" id="bid">
                         <div class="form-group row">
                          <button class="btn btn-dark" onClick={getstockbybooking_number}>Get Booking Details</button>
                          </div>
                        </div>
                      </div>
                      <div id="biid" style={{display:"none"}}>
                      <div clas="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Vendor Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000" id="vendor_name" value={vendor_name} />
                              <small class="text-muted" style={{fontSize:"0.7rem"}}>this field cannot be changed</small>
                              <code>{vendor_name_er}</code>
                              </div>
                          </div>
                      </div>
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Broker Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000" id="bname" value={bname} />
                              <small class="text-muted" style={{fontSize:"0.7rem"}}>this field cannot be changed</small>
                              <code>{bname_er}</code>
                              </div>
                          </div>
                      </div>
                      </div>
                        <div clas="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Booked Quantity<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000" id="quantity_booked" value={quantity_booked} />
                              <small class="text-muted" style={{fontSize:"0.7rem"}}>this field cannot be changed</small>
                              <code>{quantity_booked_er}</code>
                              </div>
                          </div>
                      </div>
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Dispatched Quantity<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000" id="quantity_dispatched" value={quantity_dispatched} />
                              <small class="text-muted" style={{fontSize:"0.7rem"}}>this field cannot be changed</small>
                              <code>{quantity_dispatched_er}</code>
                              </div>
                          </div>
                      </div>
                      </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Quantity<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000.00" id="quantity" value={quantity} onChange={updatequantity} />
                              <code>{quantity_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Select Godown<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Select Godown" style={{padding:"1rem"}} id="bank_id" value={bank_id} onChange={updatebank_id}>
                              <option value="">Select Godown</option>
                              {
                              Tbanks.map((curElm2,ind)=>{

                              return(
                              <>
                              <option value={curElm2.GD_id}>{curElm2.Godown_name}</option>
                              </>
                              )
                              }
                       
                                    )
                              }
                              </select>
                              <code>{bank_id_er}</code>
                            </div>
                          </div>
                        </div>                      
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Vehicle Number</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="MP08VN0009" id="vehicle_number" value={vehicle_number} onChange={updatevehicle_number} />
                              <code>{vehicle_number_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Vehicle Type</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="truck" id="vehicle_type" value={vehicle_type} onChange={updatevehicle_type} />
                              <code>{vehicle_type_er}</code>
                            </div>
                          </div>
                        </div>                   
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">E-way Bill Number</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="123412341234" id="eway_bill_no" value={eway_bill_no} onChange={updateeway_bill_no} />
                              <code>{eway_bill_no_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">E-Invoice No.</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="E987765" id="einvoice_no" value={einvoice_no} onChange={updateeinvoice_no} />
                              <code>{einvoice_no_er}</code>
                            </div>
                          </div>
                        </div>                   
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Particular<code>*</code></label>
                        <textarea class="form-control" rows="2" id="particular" value={particular} onChange={updateparticular} ></textarea>
                        <code>{particular_er}</code>
                      </div>
                  
                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}}  id="emp-submit-btn" onClick={createstock}>Submit</button>
                      
                      <br/><br/><br/>
                       <h5>Bulk Stock Upload (CSV)</h5>

<input
  type="file"
  accept=".csv"
  className="form-control"
  onChange={(e) => setStockCsv(e.target.files[0])}
/>

<br />

<button className="btn btn-secondary" onClick={uploadStockCsv}>
  Upload CSV
</button>

<br /><br />

<code>{bulkMsg}</code>

{bulkErrors.length > 0 && (
  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
    <ul>
      {bulkErrors.map((err, i) => (
        <li key={i}>{err}</li>
      ))}
    </ul>
  </div>
)}

    
                     
                   
                    </div>
                  </div>
                </div>
    </>

);

}
//}

export default Create_stock;